import React, { Component } from 'react';

export default class Success extends Component {
  componentDidMount() {
    document.getElementById('marketing-preferences-form').scrollIntoView();
  }

  render() {
    return (
      <div className="success">
        <h2 className="success-title">Thanks, we&rsquo;ve updated your preferences</h2>
        <p>Please allow up to 24 hours for these changes to take effect (updates
          to postal marketing can require 2 weeks).
        </p>
      </div>
    );
  }
}
